'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var locale = {
    'zh-cn': {
        moreBtn: '展开',
        lessBtn: '收起'
    },
    'zh-tw': {
        moreBtn: '展開',
        lessBtn: '收起'
    },
    'en-us': {
        moreBtn: 'More',
        lessBtn: 'Less'
    }
};

exports['default'] = locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/_components/@alicd/next-card/lib/locale/index.js
// module id = 356
// module chunks = 0